<template>
    <div class="row">
        <div class="col-7 div-content"> 
            <span style="padding-bottom: -15px;">
                <slot></slot>
            </span>
            <span v-if="isDefault" class="default-badge">Default</span>
        </div>
        <div class="col-5 div-content-right"> 
            <button v-if="has_replace_button" class="btn btn-outline-info btn-circle ms-1" :disabled="disabled" @click="$emit('replace')" title="Replace Content">
            <i class="fa-solid fa-right-left"></i>
            </button>
            <button class="btn btn-outline-info btn-circle ms-1" :disabled="disabled" @click="$emit('click')" title="Add to Content">
            <i class="fa-solid fa-plus"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {

    props: {
        has_replace_button: {
            type: Boolean,
            required: false,
            default: false
        },
        isDefault: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    
    emits: ["click", "replace"]
};
</script>

<style scoped>
.variable-button {
    background-color: #f0f0f0;
    /* Light gray background */
    border: 2px solid #ccc;
    /* Light gray border */
    padding: 10px 10px;
    /* Padding inside buttons */
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 15px;
    cursor: pointer;
    border-radius: 10px;
    /* Rounded corners */
}

.variable-button:hover {
    background-color: #e0e0e0;
    /* Darker gray on hover */
}

.div-content {
    display: flex;
    /* justify-content: center; */
    align-items: center;
}

.div-content-right {
    display: flex;
    justify-content: right;
    align-items: center;
}

.default-badge {
    background-color: rgba(0, 188, 212, 0.12);
    color: #00bcd4;
    border: 1px solid rgba(0, 188, 212, 0.3);
    padding: 2px 6px;
    font-size: 0.7rem;
    font-weight: 600;
    border-radius: 4px;
    margin-left: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: inline-flex;
    align-items: center;
    line-height: 1;
}
</style>